<template>
  <section class="hero-section">
    <div class="hero-bg">
      <img 
        :src="require(`@/assets/images/${bgImage}`)" 
        alt="Hero Background" 
      />
    </div>
  </section>
</template>

<script>
export default {
  name: 'HeroSection',
  data() {
    return {
      bgImage: "hero-bg.jpg"
    }
  }
}
</script>

<style scoped>
/* ===== Hero Section ===== */
.hero-section {
  width: 100%;
  min-height: 500px;
  height: auto;
  aspect-ratio: 1920 / 695;
  overflow: hidden;
  position: relative;
  background: #13358b;
}

.hero-bg {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.hero-bg img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
  display: block;
}

/* ===== 响应式 ===== */
@media (max-width: 1200px) {
  .hero-section {
    min-height: 400px;
  }
}

@media (max-width: 992px) {
  .hero-section {
    min-height: 320px;
  }
}

@media (max-width: 768px) {
  .hero-section {
    min-height: 240px;
  }
}

@media (max-width: 576px) {
  .hero-section {
    min-height: 160px;
  }
}
</style>

<!-- 
<template>
  <HeroSwiper
    :list="swiperData"
    :autoplay-time="3000"
    :loop="true"
  />
</template>

<script>
import HeroSwiper from '@/components/Hero/Swiper.vue'
export default {
  components: {
    HeroSwiper
  },
  data() {
    return {
      swiperData: [
        {
          bg: "hero-bg1.png",
          titleCn: "第四届工程缺陷与力学国际会议",
          titleEn: "The 4th International Conference on Engineering Defect Mechanics",
          date: "2026年10月16-18日",
          address: "北京会议中心"
        },
        {
          bg: "hero-bg1.png",
          titleCn: "汇聚全球力学领域顶尖学者",
          titleEn: "Multi-disciplinary Frontier Academic Exchange",
          date: "2026年10月16-18日",
          address: "北京会议中心"
        },
        {
          bg: "hero-bg1.png",
          titleCn: "工程安全与结构可靠性高峰论坛",
          titleEn: "Research on Damage, Fatigue & Structural Safety",
          date: "2026年10月16-18日",
          address: "北京会议中心"
        }
      ]
    }
  }
}
</script> 
-->